import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { HERO_IMAGE, CTA_LABEL, microbeneficios } from '../data/content';
export function Hero() {
  return <section className="w-full bg-white px-4 pb-8 pt-5 sm:px-6 sm:pb-12 sm:pt-9" data-id="element-83" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-84" data-mp="4mrxpamcehpz">
        <p className="font-display text-[0.6rem] font-extrabold uppercase tracking-[0.16em] text-brand sm:text-[0.7rem]" data-id="element-85" data-mp="129h19owp12dy">
          Reset metabólico • Protocolo práctico paso a paso
        </p>

        <h1 className="mt-2 font-display text-[1.65rem] font-extrabold uppercase leading-[1.05] tracking-tight text-brand-deep sm:text-4xl lg:text-5xl" data-id="element-86" data-mp="sbb23f29uacs">
          Antes de volver a hacer dieta,
          <span className="block text-accent" data-id="element-87" data-mp="nekkuoeqd8ps">haz un reset.</span>
        </h1>

        <p className="mx-auto mt-2.5 max-w-xl text-[0.9rem] leading-snug text-gray-600 sm:mt-3 sm:text-base" data-id="element-88" data-mp="3d2tpxe128sgn">
          Si intentas comer mejor pero vuelves a los antojos, la improvisación y
          la sensación de empezar de cero,{' '}
          <strong className="font-semibold text-brand-deep" data-id="element-89" data-mp="3o7c4291259lw">
            no necesitas exigirte más: necesitas un plan diferente.
          </strong>
        </p>

        <img src={HERO_IMAGE} alt="Metabolismo Reset: los 6 tomos digitales y el plan en tablet y celular" className="mx-auto mt-4 w-full max-w-sm sm:mt-5 sm:max-w-2xl" width={1536} height={1024} data-id="element-90" data-mp="39a32kmi1ipgg" />

        <p className="mx-auto mt-2 max-w-lg font-display text-base font-extrabold uppercase leading-tight text-brand-deep sm:text-xl" data-id="element-91" data-mp="358zoo5jjz3hv">
          Menos improvisación. Más control.{' '}
          <span className="text-brand" data-id="element-92" data-mp="2vietyt702j48">Un plan claro para cada día.</span>
        </p>

        <ul className="mx-auto mt-4 grid max-w-xl grid-cols-2 gap-2 text-left" data-id="element-93" data-mp="2hjf6hov84a9n">
          {microbeneficios.map(punto => <li key={punto} className="flex items-start gap-1.5 rounded-lg bg-brand-soft px-2.5 py-2 text-[0.78rem] font-semibold leading-tight text-brand-deep sm:px-3 sm:text-sm" data-id="element-94" data-mp="2ll0ht5s40ghq">
              <CheckIcon className="mt-px h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-95" data-mp="n9qira2x6u7y" />
              {punto}
            </li>)}
        </ul>

        <div className="mx-auto mt-5 max-w-md" data-id="element-96" data-mp="deq40266mfw6">
          <CtaButton href="#precio" location="hero" data-id="element-97" data-mp="1b0nmhzkkal84">
            {CTA_LABEL}
          </CtaButton>
          <Reassurance className="mt-2.5" items={['Acceso inmediato', '100% digital', 'Pago único', 'Sin suscripciones']} data-id="element-98" data-mp="1622l3wtkpvi3" />
        </div>

        <p className="mx-auto mt-5 max-w-xl text-[0.85rem] leading-snug text-gray-600 sm:text-[0.95rem]" data-id="element-99" data-mp="x0l48c8cdpsc">
          <strong className="font-semibold text-brand" data-id="element-100" data-mp="3lu9wgyz13ua6">
            Metabolismo Reset
          </strong>{' '}
          organiza alimentación, horarios, descanso y hábitos en un sistema
          sencillo para que sepas qué hacer cada día, sin dietas extremas ni
          reglas imposibles de mantener.
        </p>
      </div>
    </section>;
}